import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CodeIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.63695 13.9403C5.1213 13.7785 4.86903 13.2877 5.068 12.6865L9.04746 0.663897C9.24644 0.162953 9.74387 -0.137613 10.3408 0.0627644C10.8382 0.263142 11.1367 0.764085 10.9377 1.36522C10.9377 1.36522 7.1292 12.8354 6.95824 13.3879C6.78729 13.9403 6.15261 14.1022 5.63695 13.9403ZM13.4001 10.0627C13.0135 10.4493 12.3867 10.4493 12.0001 10.0627C11.6135 9.67607 11.6135 9.04927 12 8.66267L13.6 7.06267L12 5.46267C11.6135 5.07607 11.6135 4.44927 12 4.06267C12.3866 3.67607 13.0135 3.67607 13.4001 4.06267L15.7001 6.36267C16.1 6.76267 16.1 7.36267 15.7001 7.76267L13.4001 10.0627ZM4 10.0627C3.6134 10.4493 2.9866 10.4493 2.6 10.0627L0.3 7.76267C-0.1 7.36267 -0.1 6.76267 0.3 6.36267L2.6 4.06267C2.9866 3.67607 3.6134 3.67607 4 4.06267C4.3866 4.44927 4.3866 5.07607 4 5.46267L2.4 7.06267L4 8.66267C4.3866 9.04927 4.3866 9.67607 4 10.0627Z"
        />
      </svg>
    </Icon>
  );
}
